import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { DsTabOption } from '@customdesignsystem';
import { ModalService } from 'src/app/apv/core/services/modal/modal.service';
import { bringModalToFront } from 'src/app/apv/core/utils/functions';
import {
  REGIME_MODAL_TABS,
  REGIME_MODAL_TEXTS,
} from '../../constants/regime-modal.constant';

@Component({
  selector: 'regime-modal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './regime-modal.component.html',
  styleUrls: ['./regime-modal.component.scss'],
  standalone: false,
})
export class RegimeModalComponent implements OnInit {
  readonly texts = REGIME_MODAL_TEXTS;
  readonly tabs = REGIME_MODAL_TABS;
  readonly tabOptions: DsTabOption[] = REGIME_MODAL_TABS.map((tab) => ({
    label: tab.label,
    value: tab.id,
  }));

  activeTab: string = REGIME_MODAL_TABS[0].id;

  constructor(
    private readonly modalSvc: ModalService,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    bringModalToFront(this.elementRef.nativeElement);
  }

  get activeContent() {
    return this.tabs.find((tab) => tab.id === this.activeTab) ?? this.tabs[0];
  }

  showTab(tab: string): void {
    this.activeTab = tab;
  }

  closeModal(): void {
    this.modalSvc.closeModal();
  }
}
